/**
 * Local storage persistence for ad materials filters and expanded sections.
 */

export const AD_MATERIALS_FILTERS_KEY = 'ad-materials-filters'
export const AD_MATERIALS_EXPANDED_SECTIONS_KEY = 'ad-materials-expanded-sections'

export interface StoredFilters {
  target: 'all' | 'buyers' | 'sellers'
  topics: string[]
  origins: string[]
  assetTypes: string[]
}

export interface ExpandedSections {
  target: boolean
  topic: boolean
  origin: boolean
  assetType: boolean
}

export const DEFAULT_EXPANDED_SECTIONS: ExpandedSections = {
  target: true,
  topic: false,
  assetType: false,
  origin: false,
}

export const loadFromLocalStorage = <T>(key: string, defaultValue: T): T => {
  try {
    const saved = localStorage.getItem(key)
    return saved ? (JSON.parse(saved) as T) : defaultValue
  } catch (error) {
    console.error('Error loading from localStorage:', error)
    return defaultValue
  }
}

export const saveToLocalStorage = <T>(key: string, value: T): void => {
  try {
    localStorage.setItem(key, JSON.stringify(value))
  } catch (error) {
    console.error('Error saving to localStorage:', error)
  }
}

export const removeFromLocalStorage = (key: string): void => {
  try {
    localStorage.removeItem(key)
  } catch (error) {
    console.error('Error removing from localStorage:', error)
  }
}
